import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';

interface PCTabFilterProps {
    filterClick?: Function  // 导航点击事件
    boxWidth?: any   // 导航所占宽度
    zIndex?: number // 导航显示层级，默认为10 
    boxStylesData?: any // 导航最外层父级盒子自定义样式
    listStylesData?: any    // 导航list盒子自定义样式
    filterList: any    // 筛选列表数据
    currentIndex?: number  // 当前点击的索引，默认为0，第一个被选中
}

@inject('app', 'site', 'user')
@observer
class PCTabFilter extends React.Component<PCTabFilterProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        let { filterList, currentIndex = 0, boxStylesData, listStylesData } = this.props
        // 正确的 style 对象
        return <>
            <div className={styles.navBox} style={boxStylesData}>
                <div className={styles.navList} style={listStylesData}>
                    {filterList?.map((item:any, index:any) => {
                        return <div key={item?.id ?? `filter-${index}`} className={classNames(styles.navItem, currentIndex == index ? styles.navActive : '')} onClick={() => {
                            this.props.filterClick && this.props.filterClick(item, index)
                        }}>
                            {item.name}
                        </div>
                    })}
                </div>
            </div>
        </>;
        
    }
}

export default PCTabFilter;